
export const addBusiness = (businessInformation, callback) => ({
    type: 'ADD_BUSINESS',
    businessInformation,
    callback,
});

export const addBusinessSuccess = businessInformation => ({
    type: 'ADD_BUSINESS_SUCCESS',
    businessInformation,
});

export const addBusinessError = error => ({
    type: 'ADD_BUSINESS_ERROR',
    error,
});